// extracted by mini-css-extract-plugin
export default {"hlsCustom":"HlsCustom_hlsCustom__8Yici"};